import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { CategoryView } from "@bitwarden/web-vault/app/models/view/category/category.view";
import { ClassificationView } from "@bitwarden/web-vault/app/models/view/classification/classification.view";

type NamedView = AccountView | CategoryView | ClassificationView;

function duplicateNameArray(views: NamedView[], viewName: string) {
  return views.filter((view) => view.name?.toLowerCase() === viewName.toLowerCase());
}

export function checkDuplicateName(views: NamedView[], viewName: string) {
  return duplicateNameArray(views, viewName).length >= 1;
}

export function renameDuplicateName(views: NamedView[], viewName: string) {
  const accountDuplicates = duplicateNameArray(views, viewName);

  return accountDuplicates.length >= 1 ? `${viewName} (${accountDuplicates.length})` : viewName;
}
